import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatDateHeure } from "@/lib/format";
import { Vide } from "@/components/commun";

export default function Emails() {
  const [liste, setListe] = useState([]);
  const [ouvert, setOuvert] = useState(null);
  useEffect(() => { api.get("/emails-simules").then((r) => setListe(r.data)); }, []);
  return (
    <div>
      <h2 className="text-base md:text-lg font-bold">E-mails simulés</h2>
      <p className="at-muted text-sm mt-1 mb-4">Le connecteur Gmail est en simulation : les e-mails ne partent pas, ils sont consignés ici.</p>
      {liste.length === 0 && <Vide texte="Aucun e-mail envoyé pour l'instant." testId="emails-empty" />}
      <div className="space-y-2" data-testid="emails-list">
        {liste.map((m) => (
          <button key={m.id} type="button" onClick={() => setOuvert(ouvert === m.id ? null : m.id)} className="at-fiche p-4 w-full text-left block" data-testid={`email-item-${m.id}`}>
            <div className="flex flex-wrap items-baseline justify-between gap-2">
              <p className="font-bold">{m.sujet}</p>
              <span className="text-xs at-muted">{formatDateHeure(m.date)}</span>
            </div>
            <p className="text-sm at-muted break-all">À : {m.destinataire}</p>
            {ouvert === m.id && <p className="text-sm mt-3 whitespace-pre-wrap break-words at-soft p-3" data-testid={`email-body-${m.id}`}>{m.corps}</p>}
          </button>
        ))}
      </div>
    </div>
  );
}
